import { render, staticRenderFns } from "./PaginationController.vue?vue&type=template&id=f8fbb150&scoped=true&"
import script from "./PaginationController.vue?vue&type=script&lang=js&"
export * from "./PaginationController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fbb150",
  null
  
)

export default component.exports